<template>
  <div>
    <start-node-component
      v-if="nodeCfg.type === 'startNode'"
      :key="modelData.id"
      :data="formData"
      @updateData="(data) => updateData('start', data)"
    />
    <reply-node-component
      v-if="nodeCfg.type === 'replyMessageNode'"
      :key="modelData.id"
      :data="formData"
      @updateData="(data) => updateData('reply', data)"
    />
    <branch-node-component
      v-if="nodeCfg.type === 'branchNode'"
      :key="modelData.id"
      :data="formData"
      @updateData="(data) => updateData('branch', data)"
    />
    <info-collect-node-component
      v-if="nodeCfg.type === 'formSaveNode'"
      :key="modelData.id"
      :data="formData"
      @updateData="(data) => updateData('collect', data)"
    />
    <conditional-node-component
      v-if="nodeCfg.type === 'conditionalBranchNode'"
      :key="modelData.id"
      :data="formData"
      @updateData="(data) => updateData('conditional', data)"
    />
    <interface-call-node-component
      v-if="nodeCfg.type === 'interfaceInvocationNode'"
      :key="modelData.id"
      :data="formData"
      @updateData="(data) => updateData('interface', data)"
    />
    <transfer-human-node-component
      v-if="nodeCfg.type === 'transToHumanNode'"
      :key="modelData.id"
      :data="formData"
      :visible="visible"
      @updateData="(data) => updateData('transToHuman', data)"
    />
    <trans-flow-node-component
      v-if="nodeCfg.type === 'transToTaskNode'"
      :key="modelData.id"
      :data="formData"
      :visible="visible"
      @updateData="(data) => updateData('transTask', data)"
    />
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  nodeCfg: any;
  modelData: any;
  formData: any;
  visible: boolean;
}>();

const emit = defineEmits(["update:formData"]);

const updateData = (type: string, data: any) => {
  emit("update:formData", { type, data });
};
</script>
